export const TransactionStatus = {
  CANCELLED_BY_USER: 'CANCELLED_BY_USER',
  BANK_DECLINED: 'BANK_DECLINED',
  INVALID_PAYMENT_DETAILS: 'INVALID_PAYMENT_DETAILS',
  PAYMENT_METHOD_UNAVAILABLE: 'PAYMENT_METHOD_UNAVAILABLE',
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  CARD_EXPIRED: 'CARD_EXPIRED',
  INVALID_VERIFICATION_CODE: 'INVALID_VERIFICATION_CODE',
  VERIFICATION_ATTEMPTS_EXCEEDED: 'VERIFICATION_ATTEMPTS_EXCEEDED',
  AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',
  AMOUNT_LIMIT_EXCEEDED: 'AMOUNT_LIMIT_EXCEEDED',
  FREQUENCY_LIMIT_EXCEEDED: 'FREQUENCY_LIMIT_EXCEEDED',
  PAYMENT_NOT_COMPLETED: 'PAYMENT_NOT_COMPLETED',
  PAYMENT_SESSION_EXPIRED: 'PAYMENT_SESSION_EXPIRED',
  PAYMENT_LINK_INVALID: 'PAYMENT_LINK_INVALID',
  PAYMENT_LINK_ALREADY_USED: 'PAYMENT_LINK_ALREADY_USED',
  PAYMENT_TIMEOUT: 'PAYMENT_TIMEOUT',
  PROVIDER_UNAVAILABLE: 'PROVIDER_UNAVAILABLE',
  PROVIDER_PROCESSING_ERROR: 'PROVIDER_PROCESSING_ERROR',
  PAYMENT_FAILURE_UNKNOWN: 'PAYMENT_FAILURE_UNKNOWN',
  PROMOTION_NOT_SUPPORTED: 'PROMOTION_NOT_SUPPORTED',
  PROMOTION_LIMIT_EXCEEDED: 'PROMOTION_LIMIT_EXCEEDED',
  PROMOTION_NOT_FOUND: 'PROMOTION_NOT_FOUND',
} as const;
export type TransactionStatus =
  (typeof TransactionStatus)[keyof typeof TransactionStatus];
